// extracted by mini-css-extract-plugin
export default {"js":"styles_js__rnuEr","sass":"styles_sass__C-vzQ"};